<template>
  <div>
    <b-iconstack font-scale="3" class="mb-3">
      <b-icon stacked icon="flag-fill" variant="primary"></b-icon>
    </b-iconstack>

    <h4>
      Signaler cette intervention
    </h4>
    <p>
      Désirez-vous signaler cette intervention auprès de l'administrateur?
    </p>
    <hr class="my-4" />
    <div>{{ commentToEdit.pub.user.nickname }}</div>
    <small class="text-muted"
      >{{
        commentToEdit.pub.message_to
          ? commentToEdit.pub.created_date
          : commentToEdit.pub.created_at | formatDateTime
      }}
    </small>
    <b-list-group-item class="my-3"
      >{{
        commentToEdit.pub.message_to
          ? commentToEdit.pub.message
          : commentToEdit.pub.comment
      }}
    </b-list-group-item>
    <div class="d-flex justify-content-between">
      <b-btn variant="light" pill v-b-toggle.property-panel>
        Annuler
      </b-btn>
      <b-btn pill variant="primary" @click="flagComment" :disabled="loading"
        >Signaler cette intervention
        <b-spinner class="ml-2" small v-if="loading"></b-spinner>
      </b-btn>
    </div>
    <p class="mt-3">
      <small class="text-muted font-italic">
        nb.: Une fois signalée, cette publication sera masquée pour tous sauf
        pour l'enseignant et son auteur.</small
      >
    </p>
  </div>
</template>

<script>
/**
 * @file       Comment flag component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import { commentsMixin } from "@/modules/comments/mixins";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "flagComment",
  mixins: [commentsMixin],

  /**
   * Data used in the component.
   *
   * @return  {Object}
   */
  data() {
    return {
      loading: false
    };
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    /**
     * Flag comment.
     */
    flagComment() {
      this.loading = true;
      if (this.commentToEdit.pub.message_to) {
        this.$store
          .dispatch("comments/putMessage", {
            message_id: this.commentToEdit.pub.id,
            flagged: 1,
            masked: 1
          })
          .then(() => {
            this.updateStetaComment().then(() => {
              this.loading = false;
              this.$root.$emit("bv::toggle::collapse", "property-panel");
            });
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.$store
          .dispatch("comments/putComment", {
            id: this.commentToEdit.pub.id,
            flagged: 1,
            masked: 1
          })
          .then(() => {
            this.updateStetaComment().then(() => {
              this.loading = false;
              this.$root.$emit("bv::toggle::collapse", "property-panel");
            });
          })
          .catch(() => {
            this.loading = false;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
